var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettingsWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.65 24.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_2",
    "data-name": "Livello 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Livello_1-2",
    "data-name": "Livello 1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 12.4,
    y1: 2.75,
    y2: 2.75
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 14.9,
    cy: 2.75,
    r: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 5,
    y1: 12.15,
    y2: 12.15
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 7.5,
    cy: 12.15,
    r: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 17.4,
    y1: 21.55,
    y2: 21.55
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 19.9,
    cy: 21.55,
    r: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 22.4,
    y1: 2.75,
    x2: 17.4,
    y2: 2.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 22.4,
    y1: 12.15,
    x2: 10,
    y2: 12.15
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsWhite);
export default __webpack_public_path__ + "static/media/settings-white.6de934f47f97392db37e7c11f1afeeb4.svg";
export { ForwardRef as ReactComponent };